export const Titles: any[] = [
    { title: '', subTitle: '' },
    { title: 'Terrible', subTitle: '(You will not be matched with this hauler again.)' },
    { title: 'Bad', subTitle: '(You will not be matched with this hauler again.)' },
    { title: 'Dissapointing', subTitle: '(You will not be matched with this hauler again.)' },
    { title: 'OK, but had an issue' },
    { title: 'Fantastic' }
]

export const ButtonsPerLine: number = 3



// WEBPACK FOOTER //
// ./src/constants/containers/ReviewHaulerContainer.ts